module.exports = __webpack_public_path__ + "img/setting_gray.3efc17ba.svg";